export default __webpack_public_path__ + "static/media/shipping-banner.2ac7d9d5.png";